import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../../../config/config';
import { AuthModel } from "../Model/AuthModel";
import { useSearchParams } from 'react-router-dom';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import SuperAdminService from "../../SuperAdmin/Controller/Client/SACompanyListController";
import Swal from 'sweetalert2';
function ResetPassword() {

    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    useEffect(() => {
        console.log('Token:', token); // Debug token value
    }, [token]);

    const validatePassword = (password) => {
        const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return strongPasswordRegex.test(password);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = {};

        if (!password || !password.trim()) {
            errors.password = 'Password is required';
        } else if (!validatePassword(password)) {
            errors.password = 'Password must be at least 8 characters long, include uppercase, lowercase, number, and special character';
        }

        if (!confirmPassword || !confirmPassword.trim()) {
            errors.confirmPassword = 'Confirm Password is required';
        } else if (confirmPassword !== password) {
            errors.confirmPassword = 'Passwords do not match';
        }

        if (Object.keys(errors).length === 0) {
            try {

                const res = await axios.get(`${BASE_URL}/Auth/ResetPassword?token=${token}&password=${password}`);
                if (res.data.message === "Token Expired") {
                    Swal.fire(
                        "Error",
                        "The token send to you in the email is expired",
                        'error'
                    );
                }
                else if (res.data.message === "Data saved successfully") {
                    Swal.fire(
                        "Success",
                        "The password has been reset.",
                        'success'
                    );
                    redirectCallback();
                }
            } catch (err) {
                setMessage('Error resetting password.');
            }
        }
        setErrors(errors);
    };


    const [errors, setErrors] = useState({});
    const [formData, setFormData] = AuthModel();
    const [errorMessage, setErrorMessage] = useState('');



    return (

        <div class="auth-main-content auth-bg-image">
            <div class="d-table">
                <div class="d-tablecell">
                    <div class="auth-box">
                        <div class="row align-items-center">

                            <div class="col-md-12">
                                <div class="form-content">
                                    <div class="auth-logo">
                                        <img src="assets/img/logo.png" alt="Logo" style={{ "width": "70%" }} />
                                    </div>

                                    <h1 class="heading">Reset Password?</h1>
                                    {errorMessage && <p className="text-center small" style={{ color: 'red' }}>{errorMessage}</p>}
                                    <form class="" onSubmit={handleSubmit}>

                                        <div class="form-group">
                                            <label class="form-label">Password</label>

                                            <input type="password" className='form-control txtUserName' placeholder="New Password" value={password}
                                                onChange={(e) => setPassword(e.target.value)}

                                            />
                                            {errors.password && <div style={{ color: 'red' }}>{errors.password}</div>}
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Confirm Password</label>
                                            <input
                                                type="password"
                                                className="form-control txtUserName"
                                                placeholder="Confirm Password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            {errors.confirmPassword && <div style={{ color: 'red' }}>{errors.confirmPassword}</div>}
                                        </div>
                                        <div class="text-center mt-4">
                                            <button type="submit" class="btn btn-primary btn-block btn-lg mt-3 rounded-pill">Confirm</button>

                                        </div>

                                    </form>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ResetPassword;
